import { Inbox } from 'lucide-react';
import React from 'react';

interface EmptyStateProps {
  description: React.ReactNode;
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  description,
  action,
}) => (
  <div className="flex flex-col items-center justify-center px-6 py-16 text-center">
    <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 ring-1 ring-primary/15">
      <Inbox className="h-6 w-6 text-primary" />
    </div>
    <p className="mb-4 max-w-sm text-sm text-muted-foreground">{description}</p>
    {action}
  </div>
);
